/**
 * The HTML structure the API wraps an email in when its template leaves the
 * template empty — a copy of `email-default-structure-html.hbs` in core. Shown
 * as the starting point for a template of one's own.
 */
export const DEFAULT_EMAIL_TEMPLATE = `<!doctype html>
<html lang="en" style="background-color:#1f1e23;">
<head>
    <meta name="color-scheme" content="dark">
    <meta name="supported-color-schemes" content="dark">
</head>
<body style="margin:0; padding:0; background-color:#1f1e23;">
<center style="width:100%; background-color:#1f1e23;">

    <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
            <td align="center" valign="top"
                background="https://assets.adnuntius.com/cfaiae/0hsgfdxccwry0x1rhkp8nslvq0m2dgp9tk00bnzm7106fd693j.png"
                style="
                background-color:#1f1e23;
                background-image:url('https://assets.adnuntius.com/cfaiae/0hsgfdxccwry0x1rhkp8nslvq0m2dgp9tk00bnzm7106fd693j.png');
                background-repeat:no-repeat;
                background-position:center;
                background-size:cover;
                padding:40px 16px;
              ">

                <!--[if gte mso 9]>
                <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:600px;height:400px;">
                    <v:fill type="frame" src="https://assets.adnuntius.com/cfaiae/0hsgfdxccwry0x1rhkp8nslvq0m2dgp9tk00bnzm7106fd693j.png" color="#eeeeee"/>
                    <v:textbox inset="0,0,0,0">
                <![endif]-->

                <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0">
                    <tr>
                        <td align="center">
                            <table role="presentation"
                                   width="500" cellpadding="0" cellspacing="0" border="0"
                                   style="width: 100%; max-width: 500px; background-color: #eee; color: #333; border-radius: 20px 20px 0 0;">
                                <tr>
                                    <td bgcolor="#eee"
                                        style="padding: 20px; border-radius: 20px 20px 0 0; color: #333; background-color: #eee;">
                                        <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                            <tr>
                                                <td style="border-radius: 20px 20px 0 0;">
                                                    <img alt="Adnuntius logo" width="250"
                                                         src="https://assets.adnuntius.com/cfbcad/1crhrtzd6x27dzrxf7c5fpmvt7myzhz0n1w3gt0q7mv6ynmdn6.png"
                                                         style="display: block; max-width: 100%; height: auto;">
                                                </td>
                                            </tr>
                                            {{#if heading}}
                                                <tr>
                                                    <td style="padding-top: 4px;">
                                                        {{{heading}}}
                                                    </td>
                                                </tr>
                                            {{/if}}
                                            <tr>
                                                <td style="padding-top: 8px;">
                                                    {{{body}}}
                                                </td>
                                            </tr>
                                            {{#if footer}}
                                                <tr>
                                                    <td style="padding-top: 16px;">
                                                        <hr style="border: 1px solid #1bbafb; border-width: 0 0 1px 0;">
                                                        {{{footer}}}
                                                    </td>
                                                </tr>
                                            {{/if}}
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <!--[if gte mso 9]>
                </v:textbox>
                </v:rect>
                <![endif]-->

            </td>
        </tr>
    </table>

</center>
</body>
</html>
`
